import { viajesApi } from "../../../api/viajesApi";
import { setInfo, setIsLoading, setSpecialRequests } from "./travelerSlice";
import Swal from "sweetalert2";
import fileDownload from 'js-file-download'
import { setPaymentsTutorial } from "../tutorials/tutorialsSlice";

export const search = (code, success) => {
  return async (dispatch, getState) => {
    dispatch(setIsLoading(true));
    try {
      const resp = await viajesApi.get("/traveler/search", {
        params: {
          code
        }
      });
      success();
      dispatch(setInfo(resp.data.results));
    } catch (error) {
      Swal.fire("Expediente", error.response.data.msg, "error");
      dispatch(setInfo({}));
    }
  }
}

export const addPaymentMasterSale = (idMasterSaleFile, date, amount, idPaymentWay, image,
 notes, code, success) => {

  return async (dispatch, getState) => {

    try {
      var form = new FormData();
      form.append("idMasterSaleFile", idMasterSaleFile);
      form.append("date", date);
      form.append("amount", amount);
      form.append("idPaymentWay", idPaymentWay);
      if (image)
        form.append("image", image, image.Name);
      form.append("notes", notes ? notes : "");

      const resp = await viajesApi.post("/traveler/paymentMasterSale", form);
      success();
      dispatch(search(code, () => {}));
      Swal.fire("Pagos", resp.data.msg, "success");
    } catch (error) {
      Swal.fire("Pagos", error.response.data.msg, "error");
    }
  }
}

export const travelVoucher = (id, code) => {
  return async (dispatch, getState) => {
    try {
      const resp = await viajesApi.get("/traveler/travelVoucherById", {
        params: {
          id, code
        },
        responseType: 'blob',
      });
      fileDownload(resp.data, `Recibo de viaje.pdf`);
      Swal.fire("Archivos", "Comprobante descargado correctamente", "success");
    } catch (error) {
      Swal.fire("Archivos", "Ha ocurrido un error", "error");
    }
  }
}

export const downloadContract = (id, code) => {
  return async (dispatch, getState) => {
    try {
      const resp = await viajesApi.get("/traveler/downloadContract", {
        params: {
          id, code
        },
        responseType: 'blob',
      });
      fileDownload(resp.data, `Contrato.pdf`);
      Swal.fire("Archivos", "Contrato descargado correctamente", "success");
    } catch (error) {
      Swal.fire("Archivos", error.response.data.msg, "error");
    }
  }
}

export const downloadModificationPolicy = (id, code) => {
  return async (dispatch, getState) => {
    try {
      const resp = await viajesApi.get("/traveler/downloadModificationPolicy", {
        params: {
          id, code
        },
        responseType: 'blob',
      });
      fileDownload(resp.data, `Politica de modificacion.pdf`);
      Swal.fire("Archivos", "Politica de modificacion descargada correctamente", "success");
    } catch (error) {
      Swal.fire("Archivos", error.response.data.msg, "error");
    }
  }
}

export const downloadCancellationPolicy = (id, code) => {
  return async (dispatch, getState) => {
    try {
      const resp = await viajesApi.get("/traveler/downloadCancellationPolicy", {
        params: {
          id, code
        },
        responseType: 'blob',
      });
      fileDownload(resp.data, `Politica de cancelacion.pdf`);
      Swal.fire("Archivos", "Politica de cancelacion descargada correctamente", "success");
    } catch (error) {
      Swal.fire("Archivos", error.response.data.msg, "error");
    }
  }
}

export const specialRequests = (code) => {
  return async (dispatch, getState) => {
    try {

      const resp = await viajesApi.get("/traveler/specialRequests", {
        params: {
          code
        }
      });

      dispatch(setSpecialRequests(resp.data.results));
    } catch (error) {
      dispatch(setSpecialRequests([]));
    }
  }
}

export const addSpecialRequest = (code, request, success) => {

  return async (dispatch, getState) => {

    try {
      const resp = await viajesApi.post("/traveler/specialRequest", {
        code, request
      });
      success();
      dispatch(specialRequests(code));
      Swal.fire("Solicitudes", resp.data.msg, "success");
    } catch (error) {
      Swal.fire("Solicitudes", error.response.data.msg, "error");
    }
  }
}

export const getPaymentsTutorial = () => {
  return async (dispatch, getState) => {
    try {
      
      const resp = await viajesApi.get("/traveler/paymentsTutorial");
      dispatch(setPaymentsTutorial(resp.data.results));
    } catch (error) {
      dispatch(setPaymentsTutorial([]));
    }
  }
}